import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ILoginResponse } from 'src/app/interfaces/Responses/ILoginResponse';
import { environment } from 'src/environments/environment'

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  url: string = environment.urlBaseService
  private urlLogin = `${this.url}Security?UserName=`

  constructor(
    private httpClient: HttpClient) {

  }

  login(userName: string,guid:string|undefined): Observable<ILoginResponse> {

    console.log(` login  ========>  ${this.urlLogin}${userName}&guid=${guid}`)
    return this.httpClient.get<ILoginResponse>(`${this.urlLogin}${userName}&guid=${guid}`)
  }

}
